import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import APIServicenew from "../utils/APIGeneralService";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { getCookies, setCookies } from "../utils/Helper";
import { UserContext } from "../context/UserContextProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form, Button, Container, Row, Col } from "react-bootstrap";

const Login = () => {
  const navigate = useNavigate();
  const { setAccessToken } = useContext(UserContext);
  const { login } = useContext(UserContext);
  const [showPassword, setShowPassword] = useState(false);
  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = {
      "Content-Type": "application/json",
      withCredentials: true,
    };

  useEffect(() => {
    const savedusername = getCookies("savedusername");
    const savedPassword = getCookies("savedPassword");
    if (savedusername && savedPassword) {
      setusername(savedusername);
      setPassword(String(savedPassword));
      setRememberMe(true);
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!username) newErrors.username = "username is required.";

    if (!password) newErrors.password = "Password is required.";
    else if (password.length < 6) newErrors.password = "Password must be at least 6 characters.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setLoad(true);
  try {
    const res = await APIServices.post(
      "auth/sign-in",
      { username, password },
      headers
    );

    if (res?.status == 200) {
      let responce = res?.data;
      if(responce?.login){
          const accessToken = responce?.access_token;
          const userData = {user : responce.username ,email : responce.userlogin};
          login(accessToken, userData);
          showToast(res.data.message || "Login successful", "success");
          setTimeout(() => navigate("/admin/dashboard"), 2000);
      }else{
        showToast(res?.data?.detail || "Login failed", "error");
      }

    } else {
      showToast(res?.data?.detail || "Login failed", "error");
    }
  } catch (err) {
    showToast("Something went wrong", "error");
    
  } finally {
    setLoad(false);
  }
};

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
    });
  };

  return (
    <div className="wrapper">
      <section className="signin-page">
        <Container fluid className="p-0">
          <div className="signin_inner">
            <Row className="align-items-center gx-0">

              {/* LEFT IMAGE */}
              <Col md={12} lg={6}>
                <div className="signin-left">
                  <img
                    src="/images/login_bg.png"
                    className="img-fluid login_bg"
                    alt="login_bg"
                  />
                </div>
              </Col>

              {/* RIGHT FORM */}
              <Col md={12} lg={6}>
                <div className="signin-right w-100 p-4">

                  {/* Logo and Title */}
                  <div className="logo mb-4">
                    <img src="/images/logo.png" className="img-fluid mb-4" alt="logo" />
                    <h2 className="font_24 clr_blue font-600 mb-2">Log in</h2>
                    <p className="clr_grey font_14 font-400">
                      Welcome back! Please enter your details.
                    </p>
                  </div>

                  <Form onSubmit={handleSubmit} noValidate>

                    {/* username */}
                    <Form.Group className="form-floating mb-4">
                      <Form.Control
                        type="text"
                        className="form-control"
                        id="usernameInput"
                        placeholder="username"
                        value={username}
                        onChange={(e) => setusername(e.target.value)}
                        isInvalid={!!errors.username}
                      />
                      <Form.Label htmlFor="usernameInput">username *</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        {errors.username}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* PASSWORD */}
                    <Form.Group className="form-floating position-relative mb-4">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="passwordInput"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        isInvalid={!!errors.password}
                      />
                      <Form.Label htmlFor="passwordInput">Password *</Form.Label>

                      <span
                        className="position-absolute top-50 end-0 translate-middle-y pe-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => setShowPassword(prev => !prev)}
                      >
                        {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
                      </span>

                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    {/* FORGOT PASSWORD */}
                    <div className="text-end mb-4">
                      <Link to="/forgot-password" className="clr_black font_14 font-500">
                        Forgot password?
                      </Link>
                    </div>

                    {/* LOGIN BUTTON */}
                    <Button type="submit" className="btn sky_theme w-100 py-2" disabled={load}>
                      {load ? "Processing..." : "Log In"}
                    </Button>
                  </Form>

                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Login;
